import { useChatThreadActions } from "../-context/ChatThreadActionsContext";
import type { ThreadItem } from "../-hooks/useChatThreadView";
import { PendingThreadMessage, SentThreadMessage } from "./ThreadMessage";

export function ThreadDayItem({ item }: { item: ThreadItem }) {
    const {
        highlightedMessageId,
        onCopy,
        onReact,
        onRemoveReaction,
        onReply,
        onRetrySend,
    } = useChatThreadActions();

    const isHighlighted = highlightedMessageId === item.id;

    if (item.kind === "pending") {
        return (
            <PendingThreadMessage
                props={{
                    ...item.message,
                    isHighlighted,
                }}
                onRetrySend={() => onRetrySend(item.entry)}
            />
        );
    }

    return (
        <SentThreadMessage
            message={{
                ...item.message,
                isHighlighted,
            }}
            onReply={(messageText) => onReply(item.message, messageText)}
            onReact={(reaction) => onReact(item.message.id, reaction)}
            onRemoveReaction={() => onRemoveReaction(item.message.id)}
            onCopy={() => onCopy(item.message.id)}
        />
    );
}
